import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@shared/store/dialog.duck";
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import styled from "styled-components";
import { OfficeMultiSelectDropDownList } from '@shared/ui/organisms/OfficeMultiSelectDropDownList';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import {
  selectCheckedTeamIds,
  selectCheckedWorkgroupIds,
  setCheckedTeamIds, setCheckedWorkgroupIds
} from "../../../store/companyMovements.duck";
import { updateTeamAssignedOfficesRequest } from "@shared/services/TeamService";
import { updateTagsAssignedOfficesRequest } from "@shared/services/Tags";
import { loadConfig } from "@shared/store/config.duck";
import { successNotification } from "@shared/store/notification.duck";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';

export function LinkTeamOrWorkgroupToOfficeDialog() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedOffices, setSelectedOffices] = useState<OfficeEntity[]>([]);
  const checkedTeamIds = useSelector(selectCheckedTeamIds);
  const checkedWorkgroupIds = useSelector(selectCheckedWorkgroupIds);

  const close = () => {
    dispatch(closeDialog())
  };

  const onOfficeSelect = (office: OfficeEntity[]) => {
    setSelectedOffices(office);
  }

  const onLinkClick = async () => {
    if (selectedOffices.length === 0) return;
    setLoading(true);
    try {
      const officeIds = selectedOffices.map(o => o.id);
      for (const checkedTeamId of checkedTeamIds) {
        await updateTeamAssignedOfficesRequest(checkedTeamId, officeIds);
      }
      for (const checkedWorkgroupId of checkedWorkgroupIds) {
        await updateTagsAssignedOfficesRequest(checkedWorkgroupId, officeIds);
      }
      dispatch(setCheckedTeamIds([]));
      dispatch(setCheckedWorkgroupIds([]));
      dispatch(loadConfig());
      dispatch(successNotification('Linked groups to offices'));
    } catch (e) {
      dispatch(successNotification('Failed to link groups to offices'));
    } finally {
      setLoading(false);
      close();
    }
  }

  const onClearClick = async () => {
    setLoading(true);
    try {
      for (const checkedTeamId of checkedTeamIds) {
        await updateTeamAssignedOfficesRequest(checkedTeamId, []);
      }
      for (const checkedWorkgroupId of checkedWorkgroupIds) {
        await updateTagsAssignedOfficesRequest(checkedWorkgroupId, []);
      }
      dispatch(setCheckedTeamIds([]));
      dispatch(setCheckedWorkgroupIds([]));
      dispatch(loadConfig());
      dispatch(successNotification('Cleared offices from groups'));
    } catch (e) {
      dispatch(successNotification('Failed to clear offices from groups'));
    } finally {
      setLoading(false);
      close();
    }
  }

  return (
    <DialogWrapper isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title="link-group-to-office-dialog.title" />
      <OfficeMultiSelectDropDownList onSelect={onOfficeSelect} disabled={loading} label={'link-group-to-office-dialog.office-label'} />
      <PrimaryButton text={'link-group-to-office-dialog.link-button'}
                     disabled={loading}
                     style={{marginTop: 'auto', marginBottom: 16}}
                     click={onLinkClick}
                     fullWidth={true} />
      <OutlineButton text={'link-group-to-office-dialog.clear-button'}
                     disabled={loading}
                     click={onClearClick}
                     fullWidth={true} />
    </DialogWrapper>
  )
}

export const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    max-width: 100%;
    min-height: 410px;
  }
  .dialog__contentContainer, .dialog__content {
    width: 500px;
    min-height: 500px;
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
`
